import React from 'react';
import ReactDOM from 'react-dom';
import * as Sentry from '@sentry/browser';

import { checkIsProductionMode } from './utils/environment';

import { Root } from './root.component';
import { Dataset, THidePhone } from './root.types';

if (checkIsProductionMode() && !!process.env.SENTRY_DSN) {
  Sentry.init({
    dsn: process.env.SENTRY_DSN,
  });
}

((): void => {
  const element = document.getElementById('lead-form');

  if (!element) {
    console.error('Can not find html element with id="lead-form"'); // eslint-disable-line no-console
    return;
  }

  const source = element.dataset[Dataset.SOURCE];
  const titleText = element.dataset[Dataset.TITLE_TEXT] || '';
  const subtitleText = element.dataset[Dataset.SUBTITLE_TEXT] || '';
  const enablePartnerPrivacy = element.dataset[Dataset.ENABLE_PARTNER_PRIVACY];
  const enableMau = element.dataset[Dataset.ENABLE_MAU];
  const partnerPrivacyLinks = element.dataset[Dataset.PARTNER_PRIVACY_LINK] || 'https://www.pushwoosh.com/privacy-policy-website/';
  const footnoteText = element.dataset[Dataset.FOOTNOTE_TEXT];
  const buttonText = element.dataset[Dataset.BUTTON_TEXT];
  const openLinkUrl = element.dataset[Dataset.OPEN_LINK_URL];
  const mixpanelAttribute = element.dataset[Dataset.MIXPANEL_ATTRIBUTE] || '';
  const metricEvent = element.dataset[Dataset.METRIC_EVENT] || '';
  const hidePhoneData = element.dataset[Dataset.HIDE_PHONE] as THidePhone;
  const hidePhone = hidePhoneData === 'true' || hidePhoneData === true;

  const partnerPrivacyLinkList = partnerPrivacyLinks.split(',').map((value, key) => (
    {
      id: key,
      url: value,
      label: new URL(value).hostname,
    }
  ));

  if (!source || !footnoteText || !buttonText) {
    console.error('Can not find data attributes in html element with id="lead-form"'); // eslint-disable-line no-console
    return;
  }

  ReactDOM.render(
    <React.StrictMode>
      <Root
        source={source}
        titleText={titleText}
        subtitleText={subtitleText}
        footnoteText={footnoteText}
        buttonText={buttonText}
        enablePartnerPrivacy={typeof enablePartnerPrivacy !== 'undefined'}
        partnerPrivacyLinkList={partnerPrivacyLinkList}
        openLinkUrl={openLinkUrl}
        enableMau={typeof enableMau !== 'undefined'}
        mixpanelAttribute={mixpanelAttribute}
        metricEvent={metricEvent}
        hidePhone={hidePhone}
      />
    </React.StrictMode>,
    element,
  );
})();
